import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { UserContext } from "../contexts/userContext";
import CourseCard from "../components/CourseCard";
import { getUser, getUserCourse } from "../facades/UserFacade";
import Container from "@mui/material/Container";
import LinearProgress from "@mui/material/LinearProgress";
import ResultsCard from "../components/cards/ResultsCard";
import SchedulerCard from "../components/scheduler/SchedulerCard";
import useLiveLogging from "../hooks/useLiveLogging";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import EasyAccessCardRow from "../components/dashboard/EasyAccessCardRow";
import DashboardSubjectRow from "../components/DashboardSubjectRow";
import { Helmet } from "react-helmet-async";
import Link from "@mui/material/Link";
import DailyTip from "../components/daily-tip/DailyTip";
import { Button } from "@mui/material";
import FremiumCourses from "../components/fremium-courses/FremiumCourses";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     paddingTop: theme.spacing(3),
//     paddingLeft: 0,
//     paddingRight: 0,
//     height: "100%",
//   },
//   progressBar: {
//     width: "100%",
//     "& > * + *": {
//       marginTop: theme.spacing(2),
//     },
//   },
// }));
const orderedCourseIds = [5126, 5187, 94943, 5190, 249353, 3745, 3806, 371311, 191474, 3961, 10811, 10838, 96897, 10880, 249412, 4430, 4459, 10929, 4451, 4435]


export default function Dashboard() {
    const theme = useTheme();
    const userContext = useContext(UserContext);
    const [userCourseIds, setUserCoursesIds] = useState([]);
    const [reloadNeeded, setReloadNeeded] = useState(true);
    const [study_essentials, setStudyEssentials] = useState();
    const [userCourses, setUserCourses] = useState([]);
    const [loadingPct, setLoadingPct] = useState(0);
    const loadingRef = React.createRef();
    loadingRef.current = loadingPct;
    const candidateAction = useLiveLogging();
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState(false);

    useEffect(() => {
        if (!reloadNeeded)
            return;

        candidateAction({
            component: "Dashboard",
            event: "initialising Dashboard for user",
        });

        const orderCourses = (courses, orderedIds) => {
            //order the courses by the orderedIds
            const orderedCourses = [];
            orderedIds.forEach((id) => {
                const course = courses.find((course) => course == id);
                if (course) {
                    orderedCourses.push(course);
                }
            });
            //add any courses that are not in the orderedIds to the end of the list
            const unorderedCourses = courses.filter(
                (course) => !orderedCourses.includes(course),
            );
            orderedCourses.push(...unorderedCourses);
            //console.log(orderedCourses, courses, unorderedCourses);
            return orderedCourses
        }
        getUser(userContext.user)
            .then((response) => response.json())
            .then((userDetails) => {
                if (!userDetails)
                    setReloadNeeded(true);

                setUserCoursesIds(orderCourses(userDetails.courses, orderedCourseIds));
                
                setStudyEssentials(userDetails.study_essentials);
                setLoading(false);
                setReloadNeeded(false);
            })
            .catch((error) => {
                candidateAction({
                    component: "Dashboard",
                    event: "Error loading user details for Dashboard",
                    error: error,
                });
                setLoadError(true);
                setLoading(false);
            });
    }, [reloadNeeded]);

    const makePanels = (courses) => {
        if (!courses) return;

        return courses.map(function (course, index) {
            return (
                <Grid item xs={12} sm={6} md={4} key={index}>
                    <CourseCard
                        course={course.title}
                        course_id={course.id}
                        course_url={course.url_name}
                        course_img={course.image}
                    ></CourseCard>
                </Grid>
            );
        });
    };

    const getProgress = () => {
        return Math.round(
            (loadingRef.current /
                (userCourseIds.length == 0 ? 1 : userCourseIds.length)) *
            100,
        );
    };

    const registrationCompleteCallback = (course_id) => {
        //setUserCoursesIds((prevCourses) => [...prevCourses, course_id]);
        setReloadNeeded(true);
    }

    const LOADING_UI = <>
        <LinearProgress color="primary" />

        <Grid
            container
            justifyContent="center"
            direction="column"
            alignItems="center"
        >
            <Grid item xs={12}>
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                    <CircularProgress variant="determinate" value={getProgress()} />
                    <Box
                        sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography variant="caption" component="div" color="secondary">
                            {`${getProgress()}%`}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
            <Grid item>
                <Typography>One moment while we load your courses.</Typography>
            </Grid>
        </Grid></>

    const ERROR_UI = <Stack spacing={3} alignItems={"center" }
     sx={{pt : 2,height: "calc(100vh - 140px)", display: "flex", flexDirection: "column" }}>
        <Typography>
            If your courses are not loaded in a moment, please click the link below.
        </Typography>
        <Button  onClick={()=> window.location.reload()}>Click Here</Button> 
        <Typography component="div">
            Email{" "} 
            <Link
                href="mailto:help@keq.com.au"
                color="secondary"
            >
                help@keq.com.au
            </Link>{" "} if the problem continues.
        </Typography>
        </Stack>

    const CPA_MYOL_LINK_UI = <>
        <Typography>For the Full CPA Guided Learning courses, you must enrol on the CPA Website My OnLine Learning to link to your subject. </Typography>
        <Button
            variant="contained"
            color="primary"
            onClick={() => window.open("https://www.cpaaustralia.com.au", "_blank")}
        >
            Go to MYOL
        </Button>
    </>

    const DASHBOARD_UI = <>
        <Stack spacing={3} sx={{pt : 2, pb:2, height: "100%", display: "flex", flexDirection: "column" }}>
            <EasyAccessCardRow
                userCourseIds={userCourseIds}
                studyEssentials={study_essentials}
            />
             <FremiumCourses registrationCompleteCallback={registrationCompleteCallback} />
            <DailyTip />

            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                <Typography variant="h5" sx={{ mb: 1 }}>
                    My Courses
                </Typography>
                <Paper
                    elevation={0}
                    sx={{
                        "&.MuiPaper-elevation0": {
                            backgroundColor: theme.palette.grey[200],
                            borderRadius: 5,
                            flexGrow: 1,
                            overflowY: "auto", 
                        },
                    }}
                >
                    {userCourseIds.length > 0 ? (
                        userCourseIds.map(function (course, index) {
                            return <DashboardSubjectRow course={course} key={index} />;
                        })
                    ) : (<Stack alignItems="center" spacing={2}>
                        <Typography> You must sign in to the CPA Website and access your Subject this way to add the course in Guided Learning on the KnowledgEquity website.</Typography>
                        <Typography>You must do this separately for every subject you are enrolled in.</Typography>
                        <Typography>HERE IS THE LINK: </Typography>
                        <Box sx={{bgcolor:"#090d46", p:2, borderRadius:2}}>
                            <Link href="https://www.cpaaustralia.com.au/" color="#ffffff">Go to CPA MYOL</Link>
                        </Box>

                        
                    </Stack>
                    )}
                </Paper>
            </Box>
        </Stack>
    </>


    return <Container maxWidth="xl" >
        <Helmet>
            <title>Dashboard - KnowledgEquity</title>
        </Helmet>
        <Box
            sx={{
                width: "100%",
                "& > * + *": {
                    marginTop: theme.spacing(2),
                },
            }}
        >
            {loading ? LOADING_UI : null}
            {!loading && loadError ? ERROR_UI : null}
            {!loading && !loadError ? DASHBOARD_UI : null}
        </Box>
    </Container>

}
/*
 */